import { Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Table, TableBody, TableContainer, TableRow } from '@material-ui/core';
import React, { useState } from 'react';
import { FaCheck, FaEye, FaTimes, FaUserNurse } from 'react-icons/all';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MedicoDetailDTO, MedicoDTO } from '../common/Dtos';
import AuthContext from '../auth/AuthContext';
import { SDialogButton, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import TableHead from '@material-ui/core/TableHead';
import { STableCell, STableHead, STableRow } from '../common/ScrivaniaTable';

interface InserimentoPrestazioneDialogProps {
	open: boolean;
	onClose: (codiceFiscaleMedico?: string) => void;
	medico: MedicoDTO;
	medicoDetail: MedicoDetailDTO;
}

export function SceltaMedicoDialog(props: InserimentoPrestazioneDialogProps) {
	const {onClose, open, medico, medicoDetail} = props;
	const [showConfirm, setShowConfirm] = useState<boolean>(false);

	const handleConfirmation = () => {
		setShowConfirm(false);
		onClose(medico.codice_fiscale);
	}

	const handleClose = () => {
		setShowConfirm(false);
		onClose();
	}

	return (
		<Dialog
			fullWidth={true}
			maxWidth="lg"
			open={open}>
			<DialogContent>
				<STitleContainer className="mt-0">
					<STitleH3>Informazioni del medico selezionato</STitleH3>
				</STitleContainer>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="pr-2">
						<p className="font-weight-bold mb-1 d-flex align-items-center">
							<FaUserNurse className="mr-2"/> {medico.cognome + ' ' + medico.nome
							+ ' (cod. reg. ' + medico.codice_regionale + ')'}
						</p>
					</Grid>
				</Grid>
				<h4 className="mt-3">Ambulatori Personali</h4>
				<Grid container spacing={0} className="w-100 my-4">
					<Grid item xs={12}>
						<Paper>
							<TableContainer>
								<Table size="small" aria-label="purchases">
									<TableHead>
										<TableRow>
											<STableHead bgcolor="secondary">#</STableHead>
											<STableHead bgcolor="secondary">UBICAZIONE</STableHead>
											<STableHead bgcolor="secondary">ORARIO</STableHead>
										</TableRow>
									</TableHead>
									<TableBody>
										{medicoDetail.ambulatori &&
											medicoDetail.ambulatori.map((ambulatorio, index) => {
												return (
													<React.Fragment>
														<STableRow key={medico.codice_fiscale}>
															<STableCell component="th" scope="row">{index + 1}</STableCell>
															<STableCell component="th" scope="row">{ambulatorio && ambulatorio.ubicazione}</STableCell>
															<STableCell component="th" scope="row">{ambulatorio && ambulatorio.orario}</STableCell>
														</STableRow>
													</React.Fragment>
												)
											}
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</Paper>
					</Grid>
				</Grid>
			</DialogContent>
			{!showConfirm ?
				<DialogActions className="p-4">
					<SDialogButton className="float-right" onClick={() => setShowConfirm(true)}>SCEGLI</SDialogButton>
					<SDialogButton className="float-right" onClick={handleClose}>ANNULLA</SDialogButton>
				</DialogActions>
				:
				<DialogActions className="p-4 justify-content-center">
					Sicuro di voler scegliere il medico selezionato?
					<IconButton
						className="text-success"
						onClick={handleConfirmation}
					>
						<FaCheck/>
					</IconButton>
					<IconButton
						className="text-danger"
						onClick={() => setShowConfirm(false)}
					>
						<FaTimes/>
					</IconButton>
				</DialogActions>
			}
		</Dialog>
)
}
